var _path, _path2, _defs;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgMessenger = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9.642C0 4.102 4.341 0 9.94 0c5.6 0 9.94 4.105 9.94 9.645 0 5.539-4.34 9.642-9.94 9.642-1.006 0-1.97-.135-2.877-.383a.799.799 0 00-.532.04l-1.973.87a.797.797 0 01-1.116-.704l-.055-1.77a.786.786 0 00-.266-.566C1.188 15.044 0 12.54 0 9.642zM6.891 7.83l-2.92 4.632c-.28.445.266.945.683.627l3.137-2.381a.597.597 0 01.718-.002l2.323 1.742a1.491 1.491 0 002.157-.398l2.923-4.63c.278-.445-.269-.947-.686-.629L12.09 9.172a.596.596 0 01-.718.003L9.048 7.433a1.49 1.49 0 00-2.157.397z",
  fill: "url(#messenger_svg__paint0_radial_4851_49033)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.891 7.83l-2.92 4.633c-.28.444.266.944.684.626l3.136-2.38a.597.597 0 01.718-.003l2.324 1.742a1.491 1.491 0 002.157-.398l2.922-4.63c.279-.444-.268-.946-.686-.628l-3.136 2.38a.597.597 0 01-.718.003L9.049 7.433a1.491 1.491 0 00-2.158.397z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "messenger_svg__paint0_radial_4851_49033",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.33 19.88) scale(21.8685)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#09F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#A033FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#FF5280"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7061"
})))));
export default SvgMessenger;